var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-rtf';
                    var viewUrl = 'gfx/sprite.svg#view-icon-rtf';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };